import React, { useState } from "react";
import { AuthenticationFlowProps, AuthStep, MobileStep } from "./types";
import LoginScreen from "./LoginScreen";
import SignupScreen from "./SignupScreen";
import VerifyOtpScreen from "./VerifyOtpScreen";

const AuthenticationFlow: React.FC<AuthenticationFlowProps> = ({
  initialStep,
  onComplete,
  onExit,
  logStep,
}) => {
  // Internal state management
  const [currentStep, setCurrentStep] = useState<AuthStep>(initialStep);
  const [authFlow, setAuthFlow] = useState<"login" | "register">("login");
  const [mobileNumber, setMobileNumber] = useState("");
  const [otpUid, setOtpUid] = useState<string | false>(false);
  const [registerData, setRegisterData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    pincode: "",
  });

  // Internal navigation - accepts MobileStep for compatibility but only handles AuthStep
  const navigateToStep = (step: MobileStep) => {
    const validSteps: MobileStep[] = ["login", "signup", "verifyOtp"];

    if (validSteps.includes(step)) {
      setCurrentStep(step as AuthStep);
    } else {
      console.warn(
        `AuthenticationFlow: Invalid step "${step}" - ignoring navigation`
      );
    }
  };

  // Prepare authData object for child components
  const authData = {
    authFlow,
    setAuthFlow,
    mobileNumber,
    setMobileNumber,
    otpUid,
    setOtpUid,
    registerData,
    setRegisterData,
  };

  return (
    <>
      {/* Login Screen */}
      {currentStep === "login" && (
        <LoginScreen navigateToStep={navigateToStep} authData={authData} logStep={logStep} />
      )}

      {/* Signup Screen */}
      {currentStep === "signup" && (
        <SignupScreen navigateToStep={navigateToStep} authData={authData} logStep={logStep} />
      )}

      {/* Verify OTP Screen */}
      {currentStep === "verifyOtp" && (
        <VerifyOtpScreen
          navigateToStep={navigateToStep}
          authData={authData}
          onAuthComplete={onComplete}
          logStep={logStep}
        />
      )}
    </>
  );
};

export default AuthenticationFlow;
